import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { hash } from 'rsvp'
import type Store from '@ember-data/store'
import { assert } from '@ember/debug'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import type Student from 'teacher-ui-client/models/student'

export default class FastPhonicsReportingProgressStudentRoute extends Route {
  @service studentEvents!: StudentEventsService

  @service store!: Store

  async model({ student_id: studentId }: { student_id: string }) {
    const student = this.store.peekRecord<Student>('student', studentId)
    assert('could not find student in ember-data store', student)

    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const statsScope: StudentsScope = { scope: 'students', ids: [studentId] }

    const product: LegacyProductFp = 'fast_phonics'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      students: scopedData.students,
      student,
      period,
      ...stats,
    }
  }

  makeStatsRequests = (product: LegacyProductFp, scope: StudentsScope, period: NormalizedInterval) => {
    return hash({
      peaksProgressDetails: this.studentEvents.peaksProgressDetails(product, scope, period),
    })
  }
}
